<template>
    <button-sliding ref="scanDetailSlider" style="border-bottom: 2px solid var(--ion-color-grey4);">
        <scan-details-entry class="pt-1 pb-2 light-light-background purple-purple-color" :entry="entry" :edit="edit"
            @edit="scanDetailSlider.$el.open('end')" />
        <template #options-end v-if="edit">
            <slider-option-delete-boxed v-if="userStore.permission[PERMISSION_KEY.CART_DELETE]"
                @click="handleDeleteClick" />
            <slider-option-amount v-if="userStore.permission[PERMISSION_KEY.CART_UPDATE]" :modelValue="entry.quantity" :min-value="1"
                :STEP_SIZE="entry.amountStep" @update:modelValue="handleAmount" @click.stop/>
        </template>
    </button-sliding>
</template>

<script setup lang="ts">

import { ref } from "vue";
import { t } from "@/plugins/vue-i18n";

import ButtonSliding from "@/components/button/ButtonSliding.vue";
import ScanDetailsEntry from "@/components/various/ScanDetailsEntry.vue";
import SliderOptionDeleteBoxed from "@/components/sliderOptions/SliderOptionDeleteBoxed.vue";
import SliderOptionAmount from "@/components/sliderOptions/SliderOptionAmount.vue";

import { useListStore } from "@/stores/lists";
import { useUserStore } from "@/stores/user";

import { replaceToast } from "@/functions/baseToast";
import { popAlertConfirm } from "@/functions/alert";

import { CatalogItem } from "@/types/supplier";
import { PERMISSION_KEY } from "@/types/user";

interface ScanDetailsSliding {
    entry: CatalogItem;
    listId: string;
    edit?: boolean;
}

const props = defineProps<ScanDetailsSliding>()
const emit = defineEmits<{ (e: 'amount', value?: number): void }>()

const listStore = useListStore()
const userStore = useUserStore()

const scanDetailSlider = ref()

const handleAmount = (amount?: number): void => {
    emit('amount', amount);
}

const handleDeleteClick = (event: MouseEvent | TouchEvent): void => {
    event.stopPropagation()
    popAlertConfirm({
        message: t('alert.delete.scanProduct', { target: props.entry.name }),
        handler: {
            ok: deleteScanItem
        }
    })
}

const deleteScanItem = (): void => {
    listStore.deleteItemFromScanList(props.listId, props.entry.id)
    replaceToast({
        message: t('success.delete', { target: t('target.product') }),
        id: 'delete-list-success',
        cssClass: 'toast-offset-50'
    }, 'delete-list-success')
}
</script>
